import * as React from 'react';
import { Button, Menu } from 'semantic-ui-react';

import {
    BloqueHorario,
    construirBloquesHorarios,
    TablaDeCursos,
} from 'src/componentes/tablasDeCursos';
import { Contexto } from 'src/contexto';
import { CursoDTO } from '../tipos';
import FiltrosParaCursos from './FiltrosParaCursos';

type Props = Readonly<{
    cargando: boolean;
    oculto?: boolean;
    cursos: readonly CursoDTO[];
    renderizarCurso: (curso: CursoDTO) => React.ReactElement;
}>;

type State = Readonly<{
    anchoCompleto: boolean;
    bloquesHorarios: readonly BloqueHorario[];
    cursosFiltrados?: readonly CursoDTO[];
    cargando: boolean;
}>;

class TodosLosCursos extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        anchoCompleto: false,
        bloquesHorarios: [],
        cargando: true,
    };

    private cacheDeCursos: ReadonlyMap<number, React.ReactElement> = new Map();

    public componentDidMount() {
        this.actualizarCacheDeCursos();
    }

    public componentDidUpdate(prevProps: Props) {
        if (this.props.cursos !== prevProps.cursos) {
            this.actualizarCacheDeCursos();
        }
    }

    public render() {
        const { cargando, oculto, cursos } = this.props;
        const { anchoCompleto, bloquesHorarios } = this.state;

        return (
            <div hidden={oculto} style={{ marginTop: '1em' }}>
                <Menu>
                    <Menu.Item>
                        <Button
                            icon={anchoCompleto ? 'compress' : 'expand'}
                            onClick={() => {
                                this.setState(prevState => ({
                                    anchoCompleto: !prevState.anchoCompleto,
                                }));
                            }}
                        />
                    </Menu.Item>

                    <FiltrosParaCursos
                        cursos={cursos}
                        alFiltrarCursos={cursosFiltrados => {
                            this.setState({
                                cursosFiltrados,
                                bloquesHorarios: construirBloquesHorarios(
                                    cursosFiltrados,
                                    curso => this.cacheDeCursos.get(curso.id)!,
                                ),
                            });
                        }}
                    />
                </Menu>

                {!this.props.oculto && (
                    <TablaDeCursos
                        cargando={cargando}
                        bloquesHorarios={bloquesHorarios}
                        anchoCompleto={anchoCompleto}
                    />
                )}
            </div>
        );
    }

    private actualizarCacheDeCursos() {
        const { cursos, renderizarCurso } = this.props;
        this.cacheDeCursos = new Map(cursos.map(curso => [curso.id, renderizarCurso(curso)]));

        // Usa la nueva caché para recrear los bloques horarios usando el
        // filtrado previo si existe o todos los cursos si no.
        this.setState(prevState => ({
            bloquesHorarios: construirBloquesHorarios(
                prevState.cursosFiltrados ?? cursos,
                curso => this.cacheDeCursos.get(curso.id)!,
            ),
        }));
    }
}

export default TodosLosCursos;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/componentes/TodosLosCursos.tsx